
  import { Component, Vue, Prop } from 'vue-property-decorator';

  @Component
  export default class AppSwitch extends Vue {

    @Prop([Boolean]) value!: number | null;
    @Prop([Boolean]) disabled: boolean | false;
    @Prop() text: string;
    @Prop() isPinkTheme!: boolean;
    @Prop() reverse!: boolean;

    onChange () {
      this.$emit('input', !this.value);
    }
  }
